import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {purchasesApi} from '../api';

export const purchaseSummaryKeys = {
  all: (trustAccountId: string) => ['trust-accounts', trustAccountId, 'purchase-summary'] as const,
  detail: (trustAccountId: string) =>
    [...purchaseSummaryKeys.all(trustAccountId), 'detail'] as const
};

export function usePurchaseSummaryQuery(trustAccountId: string, options?: {enabled?: boolean}) {
  const client = useApiClient();

  return useQuery({
    queryKey: purchaseSummaryKeys.detail(trustAccountId),
    queryFn: () => purchasesApi.fetchPurchaseSummary(client, trustAccountId),
    enabled: !!trustAccountId && (options?.enabled ?? true),
    refetchOnMount: 'always',
    select: response => response.data
  });
}
